import { User } from "../Model/User";

export class GetUsersList {
    constructor(
      total,
      offset,
      limit,
      records,
    ) {
        this.total = total;
        this.offset = offset;
        this.limit = limit;
        this.records = records;
    }
    static createFromResponseData(data) {
      return new GetUsersList(
        data.total,
        data.offset,
        data.limit,
        data.records.map((record) => {
          return User.createFromResponseData(record);
        }),
      );
    }
  };